import React, { useContext } from 'react';
import '../../css/button.css'
import { AgentContext } from '../../context/AgentContext';


function OutlineButton({buttonTitle, buttonLabel, clickHandler, style, disabled = false, buttonClass=null}) {

    const handleClick = (e) => {
        if(disabled===false && clickHandler !==undefined){
            clickHandler(e)
        }
    }
    const styl = {
        justifyContent: 'center',
        alignItems: 'center',
        gap: 8,
        display: 'inline-flex',
        cursor: 'pointer',
        ...style
    }

    const {isB2B} = useContext(AgentContext)
    return (
        <>
            {buttonTitle && (
                <div style={{height: 10, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 12, display: 'flex'}}>
                    <div style={{justifyContent: 'flex-start', alignItems: 'flex-end', gap: 4, display: 'inline-flex'}}>
                        <div style={{color: '#707070', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '400', wordWrap: 'break-word'}}>{buttonTitle}</div>
                    </div>
                </div>
            )}
            <div className={disabled ? (buttonClass ?? 'q-outlineButton-disabled') : (buttonClass ?? `${isB2B ? 'b2b ' : ''}q-outlineButton`)} onClick={e => handleClick(e)} style={styl}>
                <div>{buttonLabel}</div>
            </div>
        </>
    )
}

export default OutlineButton;
